var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"reservation-create-page"}},[_c('vue-persian-calender',{attrs:{"events-list":_vm.events,"date-format":"YYYY-MM-DDTHH:mm:ss.SSSZ"},on:{"on-event-click":_vm.onReserveClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }